import { render, staticRenderFns } from "./RecordsPage.vue?vue&type=template&id=789a57d0&scoped=true&"
import script from "./RecordsPage.vue?vue&type=script&lang=js&"
export * from "./RecordsPage.vue?vue&type=script&lang=js&"
import style0 from "./RecordsPage.vue?vue&type=style&index=0&id=789a57d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789a57d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VIcon,VSkeletonLoader})
